import React from 'react';

export const useOnFirstRender = (callback = () => {}) => {
  const isFirstRender = React.useRef(true);

  React.useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      callback();
    }
  }, []);

  return isFirstRender.current;
};
